import img1 from '~/assets/images/lostcrusade.jpg'
import { TOKEN_2022_PROGRAM_ID } from '@solana/spl-token'
const _TOKENS = {
  PLATFORM: {
    address: 'R1NGSAaSvUVFzNecDnisqW5c7HXKj7cjFukyRVL6xui',
    symbol: 'DAG',
    name: 'DAG',
    price: 0.001,
    img: img1,
    decimals: 6,
    program: TOKEN_2022_PROGRAM_ID,
  },
} as const;

type TokenInfo = typeof _TOKENS[keyof typeof _TOKENS];
type TokenKey = keyof typeof _TOKENS | typeof _TOKENS[keyof typeof _TOKENS]['address'];
export const TOKENS: Record<TokenKey, TokenInfo> = {
  PLATFORM: _TOKENS.PLATFORM,
  [_TOKENS.PLATFORM.address]: _TOKENS.PLATFORM,
};

export const IMPORTANCE = {
  HIGH: {
    label: 'High',
    value: 'high',
    reward: 0.05,
  },
  MEDIUM: {
    label: 'Medium',
    value: 'medium',
    reward: 0.01,
  },
  LOW: {
    label: 'Low',
    value: 'low',
    reward: 0.002,
  }
}

export const COMMUNITY_URL = {
  DOCS: 'https://docs.dag.gg',
  X: 'https://x.com/dagdotgg',
  DISCORD: 'https://discord.gg/dagdotgg',
}

export const RPC_ENDPOINT = 'https://devnet.helius-rpc.com/?api-key=a2054c03-6c5d-4b0d-903f-cd54422178c0';
